import { FEATURES } from '@constants/Text'
import { registerClienteEntranceResolver } from '@modules/navegacao-v2/utils/module-entrance'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryCrm from './ia/registry'
import * as crmStore from './store'
import { resolveCrmClienteEntrance } from './utils/cliente-entrance'

export function crmModule({ store }) {
  if (typeof store.hasModule === 'function' && store.hasModule('crm')) {
    return
  }

  store.registerModule('crm', {
    ...crmStore,
    namespaced: true,
  })

  // Navegação client-centric (navegacao-v2): registra como o CRM decide rota +
  // mode do modal cliente-360 ao ser acessado com um cliente ativo.
  registerClienteEntranceResolver('crm', resolveCrmClienteEntrance)

  // Os cartões do módulo dentro da conversa (spec-010 do
  // `project-plataforma-por-chat`, [T014]). O MÓDULO se registra e o agregado
  // só consulta — é o que permite o `chat-message.vue` desenhar um cartão do
  // CRM sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa (a do
  // chat do CRM, a do Consultor, a do Especialista Fee-Based), e registrar na
  // view deixaria o mesmo `tool_result` virar cartão numa tela e
  // `fallback-card` na outra. `registerAllModules` roda uma vez, no boot,
  // antes de qualquer thread montar.
  //
  // ⚠️ `registrar` RECUSA chave repetida (por desenho — override silencioso
  // entre módulos é bug). A guarda de reentrada lá em cima (`hasModule`) é o
  // que impede uma segunda chamada de `crmModule` estourar aqui.
  registrar(registryCrm)
}

export const PERMISSION = FEATURES.CRM
